import List from "@mui/material/List";
import update from 'immutability-helper';
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useAppStore } from "../app/store";
import TodoListItem from "./todo.list.item";
import { default as TodoService } from "./todo.service";

export default function TodoList(props) {
	let {todos, setTodos, fetch} = useAppStore();
	let [newTodo, setNewTodo] = useState({});

	useEffect(() => {
		fetch(TodoService, 'getAll', undefined, setTodos);
	}, []);

	let originalTodos = [];
	if (todos?.length) {
		originalTodos = _.cloneDeep(todos);
		todos = _.orderBy(todos, 'ordinal');
		todos.forEach((todo, i) => todo.ordinal = i);

		if (props.startDate && props.endDate) {
			todos = _.filter(todos, (todo) => {
				return todo.dueDate == null || (props.startDate.isSameOrBefore(todo.dueDate) && props.endDate.isSameOrAfter(todo.dueDate));
			});
		}
	}

	const onSave = (todo) => {
		let existing = _.find(todos, { id: todo.id });
		let updated = [...todos];
		if (!existing) {
			updated.push(todo);
			setTodos(updated);
		}
	}

	const onDelete = (todo) => {
		_.remove(todos, { id: todo.id });
		setTodos(todos);
	}

	const todoDragged = useCallback((dragId, hoverId) => {
		const dragTodo = (prevTodos) => {
			const dragIndex = _.findIndex(prevTodos, { id: dragId });
			const hoverIndex = _.findIndex(prevTodos, { id: hoverId });

			// import update from 'immutability-helper'
			let tmp = update(prevTodos, {
				$splice: [
					[dragIndex, 1],
					[hoverIndex, 0, prevTodos[dragIndex]],
				],
			});
			tmp.forEach((todo, i) => todo.ordinal = i);
			return tmp;
		}

		setTodos(dragTodo(todos));
	}, []);

	const todoDropped = () => {
		let tmp = _.map(todos, _.partialRight(_.pick, ['id', 'ordinal']));
		TodoService.patchAll(tmp);
	};

	//Ensure the data context is fully up to date;
	if( !_(todos).xorWith(originalTodos, _.isEqual).isEmpty() ){
		//consider saving to db
	}

	return (
		<List dense sx={{ p: 0 }}>
			{todos?.length > 0 && todos.map((todo) => {
				return (
					<TodoListItem key={'todo-' + todo.id} todo={todo} todoDragged={(itemId, dragId) => todoDragged(itemId, dragId)} todoDropped={todoDropped} onDelete={(result) => onDelete(todo)} />
				);
			})}
			<TodoListItem todo={newTodo} onSave={(result) => onSave(result)} />
		</List>
	);
}
